/** Front .env variables
 * - declare typings (utils for later completion)
 * - inject .env values in dev mode
 * - in server mode (craft render) those will be injected through `window._ENV`
 * 
 * ! please sync all aditionals .env vars here !
 */

declare global {
  interface Window {
    __ENV: {
      VITE_SITE_URL?:string
      VITE_SITE_URL_FR?:string
      VITE_SITE_URL_EN?:string
      VITE_API_URL?:string
      VITE_ENVIRONMENT?:string
      // 3rd parties
      VITE_FB_APP_ID?: string
      VITE_GTM_TRACKING_CODE?: string
      VITE_GTM_AUTH?: string
      VITE_GTM_PREVIEW?: string
      VITE_PRERENDER_TOKEN?: string
      VITE_RECAPTCHA_ENABLED?: string
      VITE_RECAPTCHA_CLIENT_KEY?: string
      VITE_USERBACK_FRONTEND_IS_ACTIVATE?: string
      VITE_USERBACK_ACCESS_TOKEN?: string
      // debugs
      VITE_DEBUG?: string
      VITE_DEBUG_SW?: string
      VITE_DEBUG_RESPONSIVE?: string
      VITE_KONTROLS?: string
      // apis mocs
      VITE_MOC_API?: string
      VITE_MOC_GLOBALS?: string
      VITE_MOC_HOME?: string
      VITE_MOC_BIO?: string
      VITE_MOC_FUND?: string
      VITE_MOC_LEGAL?: string
      VITE_MOC_CREDIT?: string
      VITE_MOC_THEMATIQUE?: string
    }
  }
}

/* magic trick for sw no window issue */
let defaultEnv
try { defaultEnv = window?.__ENV }
catch (e) { console.log(e) }

export default defaultEnv || {
  VITE_SITE_URL:import.meta.env.VITE_SITE_URL,
  VITE_SITE_URL_FR:import.meta.env.VITE_SITE_URL_FR,
  VITE_SITE_URL_EN:import.meta.env.VITE_SITE_URL_EN,
  VITE_API_URL:import.meta.env.VITE_API_URL,
  VITE_ENVIRONMENT:import.meta.env.VITE_ENVIRONMENT,
  // 3rd parties
  VITE_FB_APP_ID: import.meta.env.VITE_FB_APP_ID,
  VITE_GTM_TRACKING_CODE: import.meta.env.VITE_GTM_TRACKING_CODE,
  VITE_GTM_AUTH: import.meta.env.VITE_GTM_AUTH,
  VITE_GTM_PREVIEW: import.meta.env.VITE_GTM_PREVIEW,
  VITE_PRERENDER_TOKEN: import.meta.env.VITE_PRERENDER_TOKEN,
  VITE_RECAPTCHA_ENABLED: import.meta.env.VITE_RECAPTCHA_ENABLED,
  VITE_RECAPTCHA_CLIENT_KEY: import.meta.env.VITE_RECAPTCHA_CLIENT_KEY,
  VITE_USERBACK_FRONTEND_IS_ACTIVATE: import.meta.env.VITE_USERBACK_FRONTEND_IS_ACTIVATE,
  VITE_USERBACK_ACCESS_TOKEN: import.meta.env.VITE_USERBACK_ACCESS_TOKEN,
  // debugs
  VITE_DEBUG: import.meta.env.VITE_DEBUG,
  VITE_DEBUG_SW: import.meta.env.VITE_DEBUG_SW,
  VITE_DEBUG_RESPONSIVE: import.meta.env.VITE_DEBUG_RESPONSIVE,
  VITE_KONTROLS: import.meta.env.VITE_KONTROLS,
  // apis mocs
  VITE_MOC_API: import.meta.env.VITE_MOC_API,
  VITE_MOC_GLOBALS: import.meta.env.VITE_MOC_GLOBALS,
  VITE_MOC_HOME: import.meta.env.VITE_MOC_HOME,
  VITE_MOC_BIO: import.meta.env.VITE_MOC_BIO,
  VITE_MOC_FUND: import.meta.env.VITE_MOC_FUND,
  VITE_MOC_LEGAL: import.meta.env.VITE_MOC_LEGAL,
  VITE_MOC_CREDIT: import.meta.env.VITE_MOC_CREDIT,
  VITE_MOC_THEMATIQUE: import.meta.env.VITE_MOC_THEMATIQUE,
}
